import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-manage-subscription-popup',
    templateUrl: './manage-subscription-popup.component.html',
    styleUrls: ['./manage-subscription-popup.component.scss'],
    standalone: false
})
export class ManageSubscriptionPopupComponent {
  @Input() priceId: string | undefined;
  @Output() proceedToPayment: EventEmitter<void> = new EventEmitter<void>();
  @Output() close: EventEmitter<void> = new EventEmitter<void>();

  onClose(): void {
    this.close.emit();
  }

  onProceed(): void {
    this.proceedToPayment.emit();
  }
}


